<div class="tag">
  <p>{{ text }}</p>
</div>
